module.exports = __webpack_public_path__ + "img/LaBase-Portofino-600px(2).2ebe3573.jpg";